import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '../../../../../assets/svg/x-icon-v2.svg';
import { ACTION_MODAL_TYPES, ActionModal } from '../../../../../DesignSystem/ActionModal';
import { Form, IInputList } from '../../../../../generic-components/Form';
import Heading from '../../../../../generic-components/Heading';
import Icon from '../../../../../generic-components/Icon';
import { UserMessage } from '../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { CREATE_NEW_PRODUCT_INPUTS, STYLES, TEXTS } from '../../consts/consts';
import { IProduct } from '../../types/types';

const {
  INVOICE_CREATION: { CREATE_NEW_CLIENT },
} = STYLES;
const {
  INVOICE_CREATION: {
    INVOICE_SERVICES_SECTION: { CREATE_NEW_ITEM },
  },
} = TEXTS;

interface IProps {
  onClose: () => void;
  onSubmit: (data: any) => void;
  isLoading: boolean;
  initialName?: string;
  initialItemData?: IProduct | null;
}

export const CreateNewProductForm = ({ onClose, onSubmit, isLoading, initialName, initialItemData }: IProps) => {
  const [inputsList, setInputsList] = useState<IInputList[]>([]);
  const [showDiscardPopup, setShowDiscardPopup] = useState<boolean>(false);
  const { t } = useTranslation();

  const handleFormSubmit = (data: any) => {
    const updateData = { ...data };
    updateData.serviceItemId = initialItemData?.serviceItemId;
    onSubmit(updateData);
  };
  const onDeleteItemSubmit = () => {
    setShowDiscardPopup(false);
    onClose();
  };
  useEffect(() => {
    const modifiedInputs = CREATE_NEW_PRODUCT_INPUTS.map((i) => {
      if (initialItemData) {
        const innerIdx = i.TYPE === 'itemDescription' ? 'description' : i.TYPE;
        i.VALUE = initialItemData[innerIdx];
      } else if (initialName && i.TYPE === 'name') i.VALUE = initialName;
      else if (!initialName && i.TYPE === 'name') i.VALUE = '';
      else i.VALUE = '';
      return i;
    });
    setInputsList(modifiedInputs);
  }, []);
  const deletePopup = (
    <ActionModal
      title={t(CREATE_NEW_ITEM.DISCARD_POPUP.TITLE)}
      description={t(CREATE_NEW_ITEM.DISCARD_POPUP.SUBTITLE)}
      mainButtonTitle={t(CREATE_NEW_ITEM.DISCARD_POPUP.DISCARD_BUTTON)}
      cancelButtonTitle={t(CREATE_NEW_ITEM.DISCARD_POPUP.CANCEL_BUTTON)}
      onSubmit={onDeleteItemSubmit}
      onCancel={() => setShowDiscardPopup(false)}
      isLoading={false}
      modalType={ACTION_MODAL_TYPES.DESTRUCTIVE}
    />
  );
  return (
    <UserMessage
      mainWrapperClassName='backdrop-blur-sm'
      contentWrapperClassName='animate-fadeIn'
      onClick={() => {}}
      id='clientEditFormWrapper'
    >
      {showDiscardPopup && deletePopup}
      <div className='w-[568px] min-h-[100px] bg-bw00 rounded-[12px]'>
        <div className={CREATE_NEW_CLIENT.WRAPPER}>
          <div className={CREATE_NEW_CLIENT.HEADER_CONTAINER}>
            <Heading
              title={
                initialItemData?.serviceItemId
                  ? t(CREATE_NEW_ITEM.MAIN_TITLE_EDIT)
                  : t(CREATE_NEW_ITEM.MAIN_TITLE_CREATE)
              }
              className={CREATE_NEW_CLIENT.MAIN_TITLE}
            />
            <Icon onClick={() => setShowDiscardPopup(true)} className={CREATE_NEW_CLIENT.CLOSE_ICON} src={CloseIcon} />
          </div>
          <div className={CREATE_NEW_CLIENT.FORM_WRAPPER}>
            <Form
              submitButtonText={
                initialItemData?.serviceItemId
                  ? t(CREATE_NEW_ITEM.SUBMIT_BUTTON_SAVE)
                  : t(CREATE_NEW_ITEM.SUBMIT_BUTTON_ADD)
              }
              submitButtonClassName={CREATE_NEW_CLIENT.SUBMIT_BUTTON}
              formClassName={CREATE_NEW_CLIENT.FORM}
              inputsList={inputsList}
              onSubmit={handleFormSubmit}
              isLoading={isLoading}
              isSuccess={false}
              isError={false}
              error=''
              onInputsFocus={() => {}}
              isSubmitValidation
            />
          </div>
        </div>
      </div>
    </UserMessage>
  );
};
